import React, {useState} from "react";
import axios from "config/axiosConfig";
import {toast} from "react-toastify";

export default function Dummy() {
    const [count, setCount] = useState(10);
    const [loading, setLoading] = useState(false);

    const createDummyMembers = () => {
        if (count < 1 || count > 100) {
            alert("1에서 100 사이의 숫자를 입력해주세요.");
            return;
        }

        if (!window.confirm(`${count}명의 더미 회원을 생성하시겠습니까?`)) {
            return;
        }

        setLoading(true);
        axios.post(`/admin/v1/members/dummy?count=${count}`)
            .then(() => {
                toast.success(`${count}명의 더미 회원이 생성되었습니다.`);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                toast.error("더미 회원 생성에 실패했습니다.");
                setLoading(false);
            });
    };

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">회원관리 > 더미 데이터 생성</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h3 className="card-title" style={{fontWeight: 'bold'}}>더미 회원 생성</h3>
                                        </div>
                                        <div className="card-body">
                                            <div className="form-group">
                                                <label>생성할 회원 수 (최대 100명)</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    style={{width: '200px'}}
                                                    value={count}
                                                    onChange={(e) => setCount(parseInt(e.target.value))}
                                                    min="1"
                                                    max="100"
                                                />
                                            </div>
                                            <button
                                                className="btn btn-primary"
                                                onClick={createDummyMembers}
                                                disabled={loading}
                                            >
                                                {loading ? "생성 중..." : "더미 회원 생성"}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}
